<template>
  <div class="map-container">
    <!-- If we lowercase "map" here, it confuses vue -->
    <phoenix-map v-if="pointsInitiallyLoaded"
                 :active-point-component="activePointComponent"
                 :points="points"
                 :boundaries="mapBoundaries" />
  </div>
</template>

<script>
import PhoenixMap from '../phoenix/map/map'
import MapPopup from './map-markers/map-popup'
import MapMarkerRedirect from './map-markers/map-marker-redirect'
import { mapBoundariesMixin } from './map-boundaries'
import { sharedMapPropsMixin } from './shared-map-props'
import { mapState } from 'vuex'

export default {
  components: { PhoenixMap },

  mixins: [ mapBoundariesMixin, sharedMapPropsMixin  ],

  props: {
    propFilters: {
      type: Array,
      required: false,
      default: () => []
    },
    markerRedirect: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState(['points', 'pointsInitiallyLoaded']),

    activePointComponent() {
      return this.markerRedirect? MapMarkerRedirect : MapPopup
    }
  }
}
</script>
